// src/hooks/useDateAgenda.js
import {useQuery} from 'react-query';
import {fetchDateAgenda} from "../api/dateAgendaApi";

export const useDateAgenda = () => {
    return useQuery(['dateAgenda'], () => fetchDateAgenda(), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
